export const iconFontAwesomeMapsPlus = (
	<i className="fa-solid fa-plus"></i>
);
